module.exports = __webpack_public_path__ + "static/media/23.b09a3c10.JPG";